<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start" style="display: flex;justify-content: flex-end;">
              <el-link    type="warning" @click="loadData"><i class="el-icon-refresh"></i>刷新数据,实时查看学生交卷状态</el-link>

        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    min-width="180"
                    prop="userName"
                    label="批阅人">
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="markingCount"
                    label="应批数量">
                    <template slot-scope="scope">
                        <div class="fx-col fx-center" v-if="scope.row.countEnable">
                            {{ scope.row.markingCount }}
                        </div>
                        <div class="fx-col fx-center" v-if="!scope.row.countEnable">
                            -
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="readCount"
                    label="实批数量">
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="unFinishCountStr"
                    label="未批数量">
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<style scoped>
</style>

<script>
export default {
    components: {},
    props: [
        "attr"
    ],
    data() {
        return {
            form: {
                keywords: "",
                examId: this.attr.examId,
            },
            tableData: [],
        }
    },
    watch: {
        "form": {
            handler: function (newValue) {
                if (event.keyCode == 32 || event.keyCode == 13) return;
                this.loadData();
            },
            deep: true
        }
    },
    methods: {
        loadData() {
            let examId = this.form.examId;
            this.$ajaxPost("/exam/teacherReadOverInfo/" + examId, {}, (data) => {
                if (data && data.result && data.success) {
                    this.tableData = data.result;
                }
            })
        },
    },
    created() {
        this.loadData();
    }
}
</script>
